import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';
import { isBetterLevel } from 'resources/skills/levels';

const initialState = Immutable({
  fetching: false,
  error: false,
  name: '',
  bestValidatedLevel: '',
  currentLevel: '',
  category: '',
  claimLevel: false,
  chatbotLevel: false,
  claimStatus: false,
  chatbotStatus: false,
  latestClaimTimestamp: false,
  latestChatbotTimestamp: false,
  isHighlighted: false,
  validations: [],
  beginnerCount: 0,
  intermediateCount: 0,
  expertCount: 0,
  skillId: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_SKILL_NAME:
      const { name } = action.payload;
      return state.set('name', name);

    case actionTypes.GET_SKILL_DETAIL.START:
      return state.set('fetching', true);

    case actionTypes.GET_SKILL_DETAIL.ERROR:
      const { error } = action.payload;
      return state.set('fetching', false).set('error', error);
    case actionTypes.GET_SKILL_DETAIL.SUCCESS:
      const entry = action.payload.skill;
      const finalValidations = filterValidations(entry.validations);
      const currentLevel = isBetterLevel(entry.level, finalValidations.bestValidatedLevel)
        ? entry.level
        : finalValidations.bestValidatedLevel;

      return state
        .set('name', entry.skill.name)
        .set('skillId', entry.skill._id)
        .set('bestValidatedLevel', finalValidations.bestValidatedLevel)
        .set('currentLevel', currentLevel)
        .set('category', entry.skill.category)
        .set('claimLevel', finalValidations.claim.level)
        .set('chatbotLevel', finalValidations.quizbot.level)
        .set('claimStatus', finalValidations.claim.validated === finalValidations.claim.level)
        .set('chatbotStatus', finalValidations.quizbot.validated === finalValidations.quizbot.level)
        .set('latestChatbotTimestamp', entry.latestChatbotTimestamp)
        .set('latestClaimTimestamp', entry.latestClaimTimestamp)
        .set('isHighlighted', !!entry.isHighlighted) // turn null to false, dont revert.
        .set('validations', entry.validations)
        .set('beginnerCount', finalValidations.beginnerCount)
        .set('intermediateCount', finalValidations.intermediateCount)
        .set('expertCount', finalValidations.expertCount)
        .set('skillId', entry._id)
        .set('fetching', false);

    case actionTypes.UPDATE_SKILL_POWER:
      return state.set('currentLevel', action.payload.currentLevel);

    default:
      return state;
  }
}

const filterValidations = validations => {
  /*
    INPUT format
    validations = [validation]
    validation = {
      validated: bool,
      level: "beginner" | "intermediate" | "expert" // all lower-case
      type: "quizbot" | "claim"
    }
  */

  let highestClaimLevel = 'beginner';
  let highestQuizbotLevel = 'beginner';
  let highestClaimValidated = 'preBeginner';
  let highestQuizbotValidated = 'preBeginner';
  const counts = {
    beginner: 0,
    intermediate: 0,
    expert: 0,
  };

  validations.forEach(validation => {
    const { validated, level, type } = validation;
    if (validated) {
      counts[level.toLowerCase()] += 1;
    }

    if (type === 'claim') {
      let isBetter = isBetterLevel(level, highestClaimLevel);
      if (isBetter) {
        highestClaimLevel = level;
        if (validated) highestClaimValidated = level;
      }
    } else if (type === 'quizbot') {
      let isBetter = isBetterLevel(level, highestQuizbotLevel);
      if (isBetter) {
        highestQuizbotLevel = level;
        if (validated) highestQuizbotValidated = level;
      }
    }
  });

  return {
    claim: {
      validated: highestClaimValidated,
      level: highestClaimLevel,
    },
    quizbot: {
      validated: highestQuizbotValidated,
      level: highestQuizbotLevel,
    },
    bestValidatedLevel: isBetterLevel(highestClaimValidated, highestQuizbotValidated)
      ? highestClaimValidated
      : highestQuizbotValidated,
    beginnerCount: counts.beginner,
    intermediateCount: counts.intermediate,
    expertCount: counts.expert,
  };
};
